import { validateProps } from '../../utils';
export const isValidContact = client => validateProps(client, ['id', 'revision']);
export const isValidContactDisplay = contactDisplay => validateProps(contactDisplay, ['id', 'name']);
//# sourceMappingURL=Contact.js.map